import _ReactPaginate from 'react-paginate';

export const ReactPaginate =
  _ReactPaginate as unknown as typeof _ReactPaginate.default;
